import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Play, Lightbulb, Image, Settings } from "lucide-react";
import VideoOfTheDayManager from "./VideoOfTheDayManager";
import DailyTipsManager from "./DailyTipsManager";
import BannerManager from "./BannerManager";

const HomePageSettingsManager = () => {
  const [activeTab, setActiveTab] = useState('video');

  const tabs = [
    {
      id: 'video',
      label: 'Video of the Day',
      icon: <Play className="w-5 h-5" />,
      component: <VideoOfTheDayManager />,
      gradient: 'from-pink-200 to-purple-200'
    },
    {
      id: 'tips',
      label: 'Daily Tips',
      icon: <Lightbulb className="w-5 h-5" />,
      component: <DailyTipsManager />,
      gradient: 'from-yellow-200 to-orange-200'
    },
    {
      id: 'banners',
      label: 'Banners',
      icon: <Image className="w-5 h-5" />,
      component: <BannerManager />,
      gradient: 'from-blue-200 to-cyan-200'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <Card className="bg-gradient-to-r from-purple-100 to-pink-100 border-purple-200 shadow-lg">
        <CardHeader>
          <CardTitle className="flex items-center gap-3 text-purple-800">
            <Settings className="w-6 h-6" />
            HomePage Settings Manager
          </CardTitle>
        </CardHeader>
      </Card>

      {/* Tab Navigation */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {tabs.map((tab) => (
          <Card
            key={tab.id}
            className={`cursor-pointer transition-all duration-300 hover:scale-105 shadow-lg border-2 ${
              activeTab === tab.id 
                ? 'border-purple-300 shadow-xl' 
                : 'border-gray-200 hover:border-purple-200'
            }`}
            onClick={() => setActiveTab(tab.id)}
          >
            <CardContent className={`p-6 bg-gradient-to-br ${tab.gradient} rounded-lg`}>
              <div className="flex items-center justify-center flex-col space-y-3">
                <div className={`p-3 rounded-full ${
                  activeTab === tab.id ? 'bg-white shadow-md' : 'bg-white/70'
                } transition-all duration-300`}>
                  {tab.icon}
                </div>
                <h3 className={`font-medium text-center ${
                  activeTab === tab.id ? 'text-gray-800' : 'text-gray-700'
                }`}>
                  {tab.label}
                </h3>
                {activeTab === tab.id && (
                  <div className="w-12 h-1 bg-purple-400 rounded-full animate-pulse"></div>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Active Component */}
      <div className="bg-gradient-to-br from-white to-purple-50 rounded-xl p-6 shadow-lg border border-purple-100">
        {tabs.find(tab => tab.id === activeTab)?.component}
      </div>
    </div>
  );
};

export default HomePageSettingsManager;